module.exports = __webpack_public_path__ + "static/media/abouttype.3fbdcbee.png";